import type { OpenAPI } from "simplydo/interfaces";

export type TagExplorerData = OpenAPI.GET<"/tags/full">["response"];

type TagExplorerCollections = TagExplorerData["collections"];

export type TagExplorerIdea = TagExplorerCollections["ideas"][number];

export type TagExplorerChallenge = TagExplorerCollections["challenges"][number];

export type TagExplorerUser = TagExplorerCollections["users"][number];

export const emptyTagExplorerData = (): TagExplorerData => ({
  tags: [],
  collections: {
    ideas: [],
    challenges: [],
    users: [],
    ideaBusinessProfiles: [],
  },
});
